import { render, staticRenderFns } from "./kw_dialog.vue?vue&type=template&id=2c8ee088&scoped=true&"
import script from "./kw_dialog.vue?vue&type=script&lang=js&"
export * from "./kw_dialog.vue?vue&type=script&lang=js&"
import style0 from "./kw_dialog.vue?vue&type=style&index=0&id=2c8ee088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ee088",
  null
  
)

component.options.__file = "kw_dialog.vue"
export default component.exports